import BasePointManager from "../../../../../src/managers/BasePointManager";
import { CENTER_OF_CIRCLE, CIRCLE_RADIUS, POINT_DEGREES } from "../../types/Config";
import { EventBus, EnumEventBus } from "../EventBus";
import { generateRandomlyRadians } from "./helpers/helperPointer";


export default class PointManager extends BasePointManager {
  private EventBus = EventBus;
  pointCheckList: Boolean[] = [];
  constructor() {
    super(CENTER_OF_CIRCLE, CIRCLE_RADIUS, POINT_DEGREES)

    this.EventBus.on(EnumEventBus.setPointChecklist, l => this.pointCheckList = l);
    this.EventBus.on(EnumEventBus.generateRandomQuadri, () => this.generateRandomShape());
    this.EventBus.on(EnumEventBus.setGrowCircleValue, (v: number) => this.setGrowCircle(v))
    this.EventBus.on(EnumEventBus.movePoints, (v: number) => this.movePoints(v));
    this.EventBus.on(EnumEventBus.setRadiansToRefs, () => this.pointRefRadians = [...this.pointRadians]);
  }

  generateRandomShape = () => generateRandomlyRadians(this, this.getRadians());
  setGrowCircle(v: number) {
    this.circleRadius = v / 5 + CIRCLE_RADIUS
    this.setCoord();
  }
  movePoints = (v: number) => {
    const points = this.getRedPoints();
    const generateOffsetRadian = (v: number) => (Math.PI / 300) * v;
    const pointInfoArr = this.pointCheckList
      .map((e, eI) => this.pointRefRadians[eI] + (e ? generateOffsetRadian(v) : 0))
      .map((r, rI) => ({ pTag: points[rI].tag, radian: r }));
    this.setRadian(pointInfoArr, true)
  }
}